/* eslint-disable jsx-a11y/alt-text */
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import './MenuPrincipal.css'
// import { images } from '../../../objetImage'
// import { faChartLine, faClockRotateLeft, faDesktop, faMessage } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SvgIcoOuvFermExcep from '../../../../img/OuvFermExceptionnelles/ICO_OuvFermExcep';
import { Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, SvgIcon } from '@mui/material';
import SvgIcoMusiqueThema from '../../../../img/Thematiques/ICO_MusiqueThema';
import SvgIcoHoraireOuv from '../../../../img/HorairesOuverture/ICO_HoraireOuv';
import SvgIcoGalec from '../../../../img/GALEC/ICO_GALEC';
import SvgIcoSpotEx from '../../../../img/SpotExpress/ICO_SpotEx';
import SvgIcoSpotAIntegrer from '../../../../img/SpotInt/ICO_SpotAInt';
import SvgIcoCataMidis from '../../../../img/CATA_MIDIS/ICO_CataMidis';
import { Link, useLocation } from 'react-router-dom';
import { Abonnement } from '../../../../Models/Abonnement/AbonnementModels';
import SvgIcoMessagePerm from '../../../../img/MessagesPermanents/ICO_MessagePerm';
import SvgIcoScamark from '../../../../img/SCAMARK/ICO_Scamark';
import SvgIcoTempsCalmes from '../../../../img/TempsCalmes/ICO_TempsCalmes';
import { Enseigne, TypeMagasin } from '../../../../Models/Magasin/MagasinModels';
import { Pack } from '../../../../Models/Pack/PackModels';

import nomSpot from './variationNomMenuSpot.json';
export interface variation{
  nomEnseinge:string
  nomMenu:string
}

export function MenuPrincipal(props: {
  abonnementsUtilisateur:Abonnement[]
  typesMagasinsUser:TypeMagasin[]
}) {
  const {abonnementsUtilisateur, typesMagasinsUser} = props
  const [presenceCampagnesGalec, setPresenceCampagnesGalec] =useState(false);
  const [presenceCampagnesScamark, setPresenceCampagnesScamark] =useState(false);
  const [presenceCampagnesCataMidis, setPresenceCampagnesCataMidis] =useState(false);
  const [presenceCampagnesSpot, setPresenceCampagnesSpot] =useState(false);

  const checkEnseignePack = (pack:Pack, enseignesTypeMag:Enseigne[])=>{
    const packEns = pack.enseigne;
    if(packEns){
      if(enseignesTypeMag.find(ens=>ens.id===packEns.id)){
        return true;
      }
      return false;
    }
    return false;
  }

  const obtentionDonneesCampagnes = useCallback(async()=>{
    const typeMagEnseigne = typesMagasinsUser.map(type=>type.enseigne).filter(type=>typeof type!=='undefined');
    
    const abonnementFiltreGalec = abonnementsUtilisateur.filter(abonnement=>abonnement.pack?.metier?.nom==='Audio' && checkEnseignePack(abonnement.pack, typeMagEnseigne) && abonnement.pack?.optionsPack?.find(option=>option.nom==="Galec on" && option.valeur));
    if(abonnementFiltreGalec.length>0)setPresenceCampagnesGalec(true);

    const abonnementFiltreScamark = abonnementsUtilisateur.filter(abonnement=>abonnement.pack?.metier?.nom==='Audio' && checkEnseignePack(abonnement.pack, typeMagEnseigne) && ( abonnement.pack?.optionsPack?.find(option=>option.nom==="Scamark on" && option.valeur) ) );
    if(abonnementFiltreScamark.length>0)setPresenceCampagnesScamark(true);

    const abonnementFiltreCataMidis = abonnementsUtilisateur.filter(abonnement=>abonnement.pack?.metier?.nom==='Audio' && checkEnseignePack(abonnement.pack, typeMagEnseigne) && abonnement.pack?.optionsPack?.find(option=>option.nom==="Cata Midis on" && option.valeur));
    if(abonnementFiltreCataMidis.length>0)setPresenceCampagnesCataMidis(true);

    const abonnementFiltreSpot = abonnementsUtilisateur.filter(abonnement=>abonnement.pack?.metier?.nom==='Audio' && checkEnseignePack(abonnement.pack, typeMagEnseigne) && abonnement.pack?.optionsPack?.find(option=>option.nom==="Spot on" && option.valeur));
    if(abonnementFiltreSpot.length>0)setPresenceCampagnesSpot(true);

  },[abonnementsUtilisateur, typesMagasinsUser]);

  const variationNomSpotExpress = useMemo(():string=>{
    const typeMagEnseigne = typesMagasinsUser.map(type=>type.enseigne).filter(type=>typeof type!=='undefined');
    if(typeMagEnseigne.length>0){
      // const nomFinal = nomSpot.nomsMenus
      const nomFinal = nomSpot.nomsMenus.find(choix=>choix.nomEnseigne.toLowerCase()===typeMagEnseigne[0].nom.toLowerCase())
      if(nomFinal)return nomFinal.nomMenu;
    }
    // if(nomSpot.nomsMenus.find(choix=>choix.nomEnseigne===typeMagEnseigne[0].nom.toLowerCase()))
    // if(typeMagEnseigne.find(ens=>ens.nom.toLowerCase()==='e.leclerc') && !typeMagEnseigne.find(ens=>ens.nom.toLowerCase()!=='e.leclerc'))return "Spot Express"
    // if(typeMagEnseigne.find(ens=>ens.nom.toLowerCase()==='bluebox') && !typeMagEnseigne.find(ens=>ens.nom.toLowerCase()!=='bluebox'))return "Spot BlueBox"
    return "Spot toutes enseigne"
  },[typesMagasinsUser])

  let location = useLocation(); //utilisation de l'url actuelle pour modifier elements entete
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
  };

  const listMenuPrincipalUser = useMemo(()=>[
    {index:1, icon: <SvgIcon className='icon' component={SvgIcoHoraireOuv} inheritViewBox/>, nom:"Horaires d'ouverture", url:'horairesPermanents'}, 
    {index:2, icon: <SvgIcon className='icon' component={SvgIcoOuvFermExcep} inheritViewBox/>, nom:'Ouv/Ferm exceptionnelles', url:'horairesExceptionnelles'}, 
    {index:3, icon: <SvgIcon className='icon' component={SvgIcoMessagePerm} inheritViewBox/>, nom:'Messages permanents', url:'messagesPermanents'}, 
    {index:4, icon: <SvgIcon className='icon' component={SvgIcoMusiqueThema} inheritViewBox/>, nom:'Musiques thématiques/Soirées', url:'musiqueThematique'}, 
    {index:5, icon: <SvgIcon className='icon' component={SvgIcoTempsCalmes} inheritViewBox/>, nom:'Temps Calme', url:'tempsCalme'}, 
    presenceCampagnesGalec ? {index:6, icon: <SvgIcon className='icon' component={SvgIcoGalec} inheritViewBox/>, nom:'Campagnes Galec', url:'galec'} : undefined, 
    presenceCampagnesScamark ? {index:7, icon: <SvgIcon className='icon' component={SvgIcoScamark} inheritViewBox/>, nom:'Campagnes Scamark', url:'scamark'} : undefined, 
    presenceCampagnesSpot ? {index:8, icon: <SvgIcon className='icon' component={SvgIcoSpotEx} inheritViewBox/>, nom:variationNomSpotExpress, url:'spotExpress'} : undefined,
    presenceCampagnesSpot ? {index:9, icon: <SvgIcon className='icon' component={SvgIcoSpotAIntegrer} inheritViewBox/>, nom:'Spots à intégrer', url:'spotIntegrer'} : undefined,
    presenceCampagnesCataMidis ? {index:10, icon: <SvgIcon className='icon' component={SvgIcoCataMidis} inheritViewBox/>, nom:'Catalogues Midis', url:'catalogueMidis'} : undefined,
  ],[presenceCampagnesCataMidis, presenceCampagnesGalec, presenceCampagnesScamark, presenceCampagnesSpot, variationNomSpotExpress]);

  useEffect(()=>{
    obtentionDonneesCampagnes();
    const urlFind = listMenuPrincipalUser.find(url=>url && url.url===location.pathname.split("/")[2])
    if(urlFind)setSelectedIndex(urlFind.index);
    return ()=>{
    }
  },[listMenuPrincipalUser, location.pathname, obtentionDonneesCampagnes])

  // useEffect(()=>{
  //   PackService().getPacks(token);
  //   OptionsPackService().getOptionsPack(token)
  // },[token])

  return (
    <div className='MenuPrincipal'>
      <List className='MenuPrincipal-all-icon-text' disablePadding>
          {listMenuPrincipalUser.map((element, index) => {
            if(element)
              return (
                <>
                  <ListItem key={index} disablePadding>
                    <Link style={{textDecoration:'none'}} to={element.url}>
                      <ListItemButton selected={selectedIndex === element.index} onClick={(event) => handleListItemClick(event, element.index)} className='MenuPrincipal-icon-text'>
                        <ListItemIcon sx={{color:'black'}}>
                          {element.icon}
                        </ListItemIcon>
                        <ListItemText sx={{color:'black'}} primary={element.nom} />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                  {element.index===5 && <Divider sx={{width:'100%'}} component="li"/>}
                </>
              )
            return null
          })}
        </List>
    </div>
  )
}